import { Link } from 'react-router-dom';
import { Button } from '../ui/button';
import { ArrowRight, FileText } from 'lucide-react';

export const HeroSection = () => {
  return (
    <section className="relative bg-white py-20 md:py-32 overflow-hidden" data-testid="hero-section">
      {/* Subtle background pattern */}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#F8F9FA_1px,transparent_1px),linear-gradient(to_bottom,#F8F9FA_1px,transparent_1px)] bg-[size:4rem_4rem] opacity-50" />
      
      <div className="relative max-w-[1200px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12 items-center">
          {/* Text Content */}
          <div className="md:col-span-7 space-y-6 md:space-y-8">
            <div className="space-y-4">
              <p className="text-[#3498DB] font-semibold tracking-[0.2em] uppercase text-sm animate-fade-in-up">
                Cloud, SRE, DevOps & AI Infrastructure
              </p>
              <h1 className="font-['Montserrat'] font-extrabold text-4xl sm:text-5xl lg:text-6xl text-[#2C3E50] leading-tight animate-fade-in-up animation-delay-100">
                Enterprise-Scale Platform & Cloud Leadership
              </h1>
              <p className="text-lg md:text-xl text-[#64748B] leading-relaxed max-w-xl animate-fade-in-up animation-delay-200">
                Building and scaling reliable, cost-efficient cloud and platform systems for global enterprises. Experienced in SRE for AI/ML systems, platform engineering, multi-cloud infrastructure, and operational excellence at Fortune 500 scale.
              </p>
            </div>

            {/* Trust Signal */}
            <p className="text-sm text-[#64748B] animate-fade-in-up animation-delay-300">
              Trusted by infrastructure leaders at Fortune 500 companies
            </p>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 animate-fade-in-up animation-delay-400">
              <Button
                asChild
                className="bg-[#3498DB] hover:bg-[#2980B9] text-white px-8 py-6 text-base shadow-[0_4px_14px_0_rgba(52,152,219,0.39)]"
                data-testid="hero-cta-research"
              >
                <Link to="/writing">
                  <FileText size={18} className="mr-2" />
                  View Research
                </Link>
              </Button>
              <Button
                asChild
                variant="outline"
                className="border-2 border-[#2C3E50] text-[#2C3E50] hover:bg-[#2C3E50] hover:text-white px-8 py-6 text-base"
                data-testid="hero-cta-consultation"
              >
                <Link to="/contact">
                  Book Consultation
                  <ArrowRight size={18} className="ml-2" />
                </Link>
              </Button>
            </div>
          </div>

          {/* Hero Image */}
          <div className="md:col-span-5 animate-scale-in animation-delay-300">
            <div className="relative">
              <div className="absolute -inset-4 bg-[#3498DB]/10 rounded-2xl blur-xl" />
              <img
                src="https://images.pexels.com/photos/14760650/pexels-photo-14760650.jpeg"
                alt="Cloud infrastructure visualization"
                className="relative w-full h-[300px] md:h-[400px] object-cover rounded-xl shadow-lg"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
